import HeaderModule from "modules/headerObserver.module";
import NavigationModule from "modules/navigation.module";
import AnchorObserverModule from "modules/anchorObserver.module";
import TextCarouselModule from "core/textCarousel.core";
import ModalModule from "modules/modal.module";


class App {

	private headerModule = new HeaderModule()
	private navigationModule = new NavigationModule()
	private anchorModule = new AnchorObserverModule()
	private textCarouselModule = new TextCarouselModule();
	// private modalModule = new ModalModule("performanceModal", {
	// 	modalOpenTime: 8_000,
	// });

	constructor() {
		/* ── Header ─────────────────────────────── */
		this.headerModule.addWatcherToHeaderOnScroll()
		this.headerModule.setHeaderShadow()
		// this.headerModule.setMainElementToMatchHeader()
		// this.headerModule.addBoxShadowWhenNotPrimaryBg()


		/* ── Navigation ─────────────────────────── */
		this.navigationModule.disableAttributes()
		this.navigationModule.handleActiveLinkOnPageLoad()
		this.navigationModule.handleNavBarDropdown()
		// this.navigationModule.handleNavBarToggleButton()

		/* ── Anchor Observer ────────────────────── */
		this.anchorModule.toggleAnimation();

		/* ── Text Carousel ──────────────────────── */
		// this.textCarouselModule.init();

		/* ── Modal ──────────────────────── */
		// this.modalModule

		/* Dev helper – not related to navigation */
		localStorage.clear();
	}
}

export const myApp = new App();
